// tw
export default {
  offline_message: '未連線',
  rotate_message: '請把手機轉為直向',
  errors: {
    '500': '請稍後再試',
    'offline': '離線狀態, 請檢查網絡連線',
    exceed_daily_order_limit: '抱歉，您已超出本日訂單限額。',
    out_of_stock: '此貨品暫時售罄。請先從購物籃移除並繼續確認訂單。',
    not_enough_stock: '庫存不夠。',
    not_allow_to_checkout: '此產品暫時未能自助購買。如欲購買此產品，請聯絡美容顧問協助。請移除此產品以繼續前往結賬。',
    max_items_reached: '抱歉，每張訂單只可購買不多於20件產品。',
    max_qty_reached: '抱歉，每件產品只可購買不多於{{max_qty}}件。'
  },
  labels: {
    exclusive: '獨家產品',
    new: 'New',
    limited_edition: '限量產品'
  },
  order_ready: '你的訂單 #{{ticket_number}} 已可取貨',
  menu_list: {
    home: 'Home',
    all: '所有{{category}}'
  },
  containers: {
    cart: {
      title: '購物籃',
      empty_message: '你的購物籃暫沒有貨品',
      shop_now: '立即購物',
      subtotal: '合計 ',
      items: {
        one: '(1件產品)',
        other: '({{count}}件產品)'
      },
      place_order_button: '確認訂單',
      place_order: '確認訂單',
      place_order_message: '是否確認訂單？',
      payment_redirect_message: '你將被轉到付款頁面，請在10分鐘內完成付款。',
      pay_at_cashier_message: '請於完成訂單後一小時内前往收銀處付款。',
      yes: '是',
      no: '否',
      dismiss: '返回',
      bag_charge_message: ' 根據香港塑膠購物袋環保徵費計劃，每個購物袋將收取 HK${{fee}} 之費用。',
      // staff_code_label: '職員專用', // TODO: i18n
      // staff_code_placeholder: '職員編號', // TODO: i18n
      load_error: '請稍後再試',
      reload_btn: '重新載入',
      deferred_payment: '其它付款方式',
      notice_title: '注意',
      invalid_card: '付款卡無效',
      other_footnote: '如欲以現金或銀聯支付，請前往收銀處付款。以现金或银联支付，请前往柜檯付款。'
    },
    check_in: {
      select_language: '選擇語言',
      notice_message: '很抱歉，你必須先辦理登入程序方可開始。請向職員出示二維碼進場。',
    },
    order_list: {
      title: '你的訂單',
      thank_you_title: '感謝你的訂購',
      pay_and_collect_message: '請於付款後前往收銀處領取貨品。',
      collect_message: '您已成功付款，我們將於準備完成後通知你前往收銀處領取貨品',
      order_ready_title: '你的訂單已可取貨',
      ticket_no_label: '你的取貨編號',
      qrcode_message: '取貨時請出示此QR code',
      ticket_number: '取貨編號: {{ticket_number}}',
      order_state: {
        ready_for_collection: '已可取貨',
        in_progress: '仍在處理'
      },
      empty_message: '你還未有任何訂單'
    },
    explore: {
      title: '探索',
      browse_all_products: '瀏覽所有產品',
      search_placeholder: '輸入產品名稱',
      hint: '提示：輸入會場內的快速編碼(EXPRESS CODE)',
      tutorial: '觀看導覽' // TODO: i18n
    },
    product_groups: {
      title: 'Products', // TODO: i18n
      exclusive: '獨家產品'
    },
    product_search_result: {
      title: '產品搜尋結果',
      add_to_bag: '加入購物籃',
      added_to_bag: '已加入購物籃',
      continue: '繼續',
      out_of_stock: '缺貨'
    },
    thank_you: {
      title: '謝謝',
      sorry: '抱歉',
      message: '感謝您使用自助購物服務。',
      wechat_discover_message: '關注香奈兒微信公衆號，探索更多產品資訊。',
      session_expired: 'Session Not Found',
      session_expired_message: '如欲再次購買任何產品，請使用自助購物服務。'
    },
    info_form: {
      title: '個人資料',
      register_message: '立即注冊成爲會員，以獲取更多專享禮遇。',
      first_name: '名',
      last_name: '姓',
      phone: '手提電話',
      required: '必填',
      accept_pics: '本人希望通過電子郵件、電話、社交媒體、短訊、即時通訊、郵件以及不時獲得本人同意的任何其他方式收到上文',
      pics_title: '收集個人資料聲明',
      accept_pics_2: '中所述的直接推廣資訊。',
      pics: '閣下特此代表閣下本人及閣下提供的個人資料所涉及的任何其他人同意Chanel（與我們的母公司及關聯公司統稱「CHANEL」）將閣下所提供的個人資料（「個人資料」）用於以下目的：銷售管控及記錄；根據閣下的個人特質、閣下的重要日子及其他個人資料對閣下的CHANEL體驗進行個性化；處理產品交付及退貨；提供客戶服務及處理閣下的查詢及投訴；研究及產品開發；以及在閣下同意的前提下，就CHANEL時裝及配飾、腕錶及高級珠寶、香水及彩妝進行直接推廣。在閣下同意的前提下，CHANEL可能會將個人資料披露或傳送予全球CHANEL集團公司及向CHANEL提供與上述用途相關的管理、推廣及研究服務的代理商及供應商，或與之共用個人資料。若閣下要求CHANEL不得將個人資料作上述直接推廣用途，CHANEL將遵循閣下的要求。如閣下欲提出此等要求，敬請聯絡客戶服務代表。閣下特此同意將個人資料轉移至香港以外的地方以作本聲明所述的用途或其他直接相關的用途。閣下有權存取、更正或删除個人資料。如閣下希望CHANEL從聯絡及郵遞名單中刪除閣下的名字，或希望查詢有關個人資料的事宜（包括存取及更正資料），敬請聯絡CHANEL的客戶服務代表，地址為香港中環置地廣場告羅士打大廈四十一樓（電郵地址：customerservice@chanel.com.hk）。閣下可於www.chanel.com.hk獲得更多關於CHANEL私隱政策的詳情。',
      place_order: '提交',
      guest_checkout: '以暱名繼續'
    }
  },
  header_menu: {
    menu: '選單',
    search: '搜尋',
    cart: '購物籃',
    my_qr: '二維碼'
  },
  searchbar: {
    placeholder: '搜尋', // TODO: i18n
    cancel: '取消',
    reset: '重設'
  },
  shades_list: {
    title: '選擇色調'
  },
  sizes_list: {
    title: '選擇大小'
  },
  empty_product_search_result: {
    title: `
      很抱歉，找不到與<div class="keyword">「{{keyword}}」</div>相符的產品
    `,
    message: '請試用其他搜尋關鍵字或輸入'
  },
  payment_options_bottom_sheet: {
    select_payment: '選擇付款方式'
  }
}



// WEBPACK FOOTER //
// ./src/locales/tw.js